import React, { useState } from 'react';
import { Users, ExternalLink, AlertTriangle } from 'lucide-react';
import { createStudentViewPath } from '../../utils/studentRoutes';

const MenteeListWidget = ({ mentees, onRefresh }) => {
  const [selectedMentee, setSelectedMentee] = useState(null);

  const lowAttendanceMentees = mentees.filter(m => 
    m.attendance && m.attendance.overallPercentage < 75
  );

  return (
    <div>
      {/* Alert for low attendance */}
      {lowAttendanceMentees.length > 0 && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg flex items-start space-x-2">
          <AlertTriangle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
          <div className="text-sm text-red-800">
            <strong>{lowAttendanceMentees.length}</strong> mentee(s) have attendance below 75%
          </div>
        </div>
      )}

      {/* Mentees Grid */}
      {mentees.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          <Users className="w-12 h-12 mx-auto mb-2 text-gray-300" />
          <p>No mentees assigned</p>
        </div>
      ) : (
        <div className="grid gap-3">
          {mentees.map(mentee => (
            <div
              key={mentee.rollNumber}
              className="border rounded-lg p-4 hover:shadow-md transition-shadow cursor-pointer"
              onClick={() => setSelectedMentee(mentee)}
            >
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <h4 className="font-semibold text-gray-900">
                    {mentee.firstName} {mentee.surname}
                  </h4>
                  <p className="text-sm text-gray-600">{mentee.rollNumber}</p>
                  
                  {mentee.attendance && (
                    <div className="mt-2 flex items-center space-x-4 text-sm">
                      <span className={`font-medium ${
                        mentee.attendance.overallPercentage >= 75 ? 'text-green-600' : 'text-red-600'
                      }`}>
                        {mentee.attendance.overallPercentage?.toFixed(2)}% Attendance
                      </span>
                      {mentee.attendance.overallPercentage < 75 && (
                        <span className="px-2 py-0.5 bg-red-100 text-red-700 rounded text-xs">
                          At Risk
                        </span>
                      )}
                    </div>
                  )}
                </div>
                
               <button
            onClick={() => window.open(createStudentViewPath('/student/mahiti', mentee.rollNumber), '_blank')}
            className="ml-4 flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg hover:from-indigo-700 hover:to-purple-700 shadow-md hover:shadow-lg transition-all"
          >
                  <ExternalLink className="w-5 h-5" />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MenteeListWidget;
